import { useCallback, useEffect, useState } from "react";
import { api, fmtUSD } from "@/lib/api";
import { Band } from "./FraudShared";
import { FraudDetail } from "./FraudDetail";

const FILTERS = [["", "All"], ["red", "Red"], ["yellow", "Yellow"], ["green", "Green"]];

export function FraudQueue() {
  const [band, setBand] = useState("red");
  const [data, setData] = useState(null);
  const [sel, setSel] = useState(null);
  const load = useCallback(() => api.get(`/fraud/transactions${band ? `?band=${band}` : ""}`).then((r) => { setData(r.data); setSel((s) => (r.data.items.some((i) => i.id === s) ? s : r.data.items[0]?.id)); }), [band]);
  useEffect(() => { load(); }, [load]);
  if (!data) return <div className="text-sm text-slate-500">Loading…</div>;
  return (
    <div className="grid xl:grid-cols-[360px_1fr] gap-5">
      <div className="space-y-2 min-w-0">
        <div className="flex gap-1.5" data-testid="fraud-band-filter">
          {FILTERS.map(([k, l]) => <button key={l} data-testid={`fraud-filter-${l.toLowerCase()}`} onClick={() => setBand(k)} className={`text-[11px] font-semibold px-2.5 py-1.5 rounded-lg border ${band === k ? "bg-slate-900 text-white border-slate-900" : "bg-white border-slate-200 text-slate-600"}`}>{l}{k ? ` ${data.counts[k]}` : ""}</button>)}
        </div>
        <div className="space-y-2 max-h-[70vh] overflow-y-auto thin-scroll pr-1">
          {data.items.map((i) => (
            <button key={i.id} data-testid={`fraud-item-${i.id}`} onClick={() => setSel(i.id)} className={`w-full text-left p-3 rounded-xl border transition-colors ${sel === i.id ? "bg-white border-sky-300 shadow-[0_1px_4px_rgba(2,132,199,0.15)]" : "bg-white/60 border-slate-200 hover:bg-white"}`}>
              <div className="flex justify-between gap-2"><span className="text-xs font-semibold text-slate-900 truncate">{i.customer}</span><Band b={i.scored.band} s={i.scored.score} /></div>
              <div className="text-[11px] text-slate-500 mt-1 num">{i.id} · {i.rail} · {i.direction} · {fmtUSD(i.amount_usd)}</div>
              <div className="flex justify-between text-[11px] mt-0.5"><span className="text-slate-600">{i.status}{i.label ? ` · ${i.label.outcome}` : ""}</span>{i.shadow.map((s) => <span key={s.version} className="text-sky-700">{s.version}: {s.band} {s.score}</span>)}</div>
            </button>))}
          {!data.items.length && <div className="text-xs text-slate-500 p-3">No payments in this band.</div>}
        </div>
      </div>
      {sel ? <FraudDetail key={sel} id={sel} onChange={load} /> : <div />}
    </div>
  );
}
